<div class="panels" [ngClass]="layoutService.layout$ | async">
  @if (layoutService.document$ | async; as document) {
    <app-document-viewer
      [document]="document"
      (closed)="layoutService.previewDocument(null)"
    ></app-document-viewer>
  }
  @if (layoutService.contract$ | async; as contract) {
    @let componentType = layoutService.componentType$ | async;
    @if (componentType === 'embauche') {
      <app-embauche-dialog
        [contract]="contract"
        (canceled)="onCancelContractEdit()"
        (saved)="onContractSaved()"
      ></app-embauche-dialog>
    }
    @if (componentType === 'social-security') {
      <app-social-security-document-and-number-dialog
        [inputData]="{ contractId: contract.id! }"
        (canceled)="onCancelContractEdit()"
        (saved)="onCancelContractEdit()"
      ></app-social-security-document-and-number-dialog>
    }
  }
</div>
